import TimeGrid from "react-big-calendar/lib/TimeGrid";
import { addDays, format, startOfWeek } from "date-fns";
import { es } from "date-fns/locale";

const dias = (date) => {
  const s = startOfWeek(date, { weekStartsOn: 1 });
  return Array.from({ length: 6 }, (_, i) => addDays(s, i));
};

export function SemanaSab(props) {
  return <TimeGrid {...props} range={dias(props.date)} eventOffset={15} />;
}
SemanaSab.range = dias;
SemanaSab.navigate = (date, action) => (action === "PREV" ? addDays(date, -7) : action === "NEXT" ? addDays(date, 7) : date);
SemanaSab.title = (date) => {
  const r = dias(date);
  return `${format(r[0], "d MMM", { locale: es })} – ${format(r[5], "d MMM yyyy", { locale: es })}`;
};
